import { render, staticRenderFns } from "./ClonePromotionButton.vue?vue&type=template&id=3c2593c9&"
import script from "./ClonePromotionButton.vue?vue&type=script&lang=ts&"
export * from "./ClonePromotionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports